import { render, staticRenderFns } from "./PPage.vue?vue&type=template&id=d30c5742&"
import script from "./PPage.vue?vue&type=script&lang=ts&"
export * from "./PPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports